import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tooltip} from 'primeng/tooltip';


@Component({
	selector: 'chatbot-icon',
	template: `
    <div class="chatbot-icon-container"
      [class.minimized]="minimized"
      [class.mobile]="mobile"
      (mouseenter)="restore()"
      (click)="restore()">
      <!-- X di chiusura -->
      @if (!minimized) {
        <button type="button" class="chatbot-close-btn" (click)="minimize($event)">
          <i class="pi pi-times"></i>
        </button>
      }
      <img [src]="iconChatbot" class="svg-container" alt="Chatbot icon" pTooltip="Myarp@ Chatbot" tooltipPosition="left"
        (click)="!minimized ? chatbotClicked.emit() : null">
      </div>
    `,
	imports: [
    Tooltip
],
	styles: `
    .chatbot-icon-container {
      position: fixed;
      height: 4rem;
      aspect-ratio: 1/1;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 10px;
      right: 10px;
      z-index: 1000;
      /* animazione */
      transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
    }

    /* stato visibile */
    .chatbot-icon-container:not(.minimized) {
      transform: translateX(0);
      opacity: 1;
    }

    /* stato minimizzato → scivola fuori */
    .chatbot-icon-container:not(.mobile).minimized {
      transform: translateX(70%) scale(0.75);
      opacity: 0.6;
      transform-origin: right center;
    }

    /* hover su linguetta */
    .chatbot-icon-container.minimized:hover {
      transform: translateX(0);
      opacity: 1;
    }

    .chatbot-icon-container.minimized.mobile {
      transform: scale(0.5);
      opacity: 0.5;
      transform-origin: bottom right;
    }

    .svg-container {
      background-color: var(--primary-color);
      width: 100%;
      height: 100%;
      border-radius: 50%;
      cursor: pointer;
      padding: 0.5rem;
    }

    .chatbot-close-btn {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 1.25rem;
      height: 1.25rem;
      border-radius: 50%;
      background: var(--surface-0);
      border: 1px solid var(--surface-border);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
      z-index: 2;
    }

    .chatbot-close-btn i {
      font-size: 0.75rem;
      color: var(--text-color-secondary);
    }

    .chatbot-close-btn:hover {
      background: var(--surface-100);
    }
	`
})
export class ChatbotIconComponent implements OnInit {

	@Input({required: true}) iconChatbot !: string;

	@Output() chatbotClicked = new EventEmitter<void>();

	minimized = false;
	mobile = false;

	ngOnInit() {
		this.mobile = this.isMobile; // proprietà booleana
	}

	minimize(event: MouseEvent): void {
		event.stopPropagation();
		this.minimized = true;
	}

	restore(): void {
		if (this.minimized) {
			setTimeout(() => this.minimized = false, 150);
		}
	}

	get isMobile(): boolean {
		const ua = navigator.userAgent;
		return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(ua);
	}


}
